'use es6';

export const DEFAULT_PAGINATION_LIMIT = 15;
export const DEFAULT_ORDER_BY = Object.freeze({
  CUSTOM_WIDGETS: '-updated',
  LAYOUTS: '-updated',
  TEMPLATES: '-updated',
  GLOBAL_GROUPS: '-updated',
  GLOBAL_WIDGETS: '-updated',
  MARKETPLACE: '-updated'
});